module.exports = __webpack_public_path__ + "img/complete-userinfo-bg-mb.5c55308.png";